import { render } from "./ApiIntegration.vue?vue&type=template&id=7486414d&scoped=true"
import script from "./ApiIntegration.vue?vue&type=script&lang=js"
export * from "./ApiIntegration.vue?vue&type=script&lang=js"

import "./ApiIntegration.vue?vue&type=style&index=0&id=7486414d&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7486414d"]])

export default __exports__